/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { parseNumber } from '@jalik/form-parser'
import FormNumberField, {
  FormNumberFieldProps
} from '../../../../client/js/components/form/fields/FormNumberField'

function SurfaceField (props: FormNumberFieldProps) {
  const { name = 'surface', ...others } = props
  const intl = useIntl()
  return (
    <FormNumberField
      label={intl.formatMessage({
        id: 'surface',
        defaultMessage: 'Superficie'
      })}
      name={name}
      parser={parseNumber}
      suffix={' m²'}
      {...others}
    />
  )
}

export default SurfaceField
